import styled from 'styled-components';

export default styled.section`
  padding: 5.875rem 0 0;
  border-bottom: solid 1px ${props => props.theme.colors.grey4};

  @media (min-width: ${props => props.theme.breakpoints.desktop}) {
    padding: 2.875rem 0 0;
  }

  h2,
  h3 {
    margin: 0;
  }

  p {
    margin-top: 0.375rem;
    margin-bottom: 0;
  }

  .links {
    list-style: none;
    margin: 0;
    padding: 1rem 0 2.25rem;
  }

  .link {
    padding: 0;
    margin: 0;

    a {
      padding: 0.375rem 0;
      display: flex;
      flex-direction: row;
      align-items: center;
      color: ${props => props.theme.colors.bedtime};
      text-decoration: none;
      line-height: 1em;
    }
  }

  .title {
    padding: 0.375rem 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    color: ${props => props.theme.colors.bedtime};
    text-decoration: none;
    line-height: 1em;
  }

  .type-h4 {
    font-size: ${props => props.theme.type.h4};
    line-height: ${props => props.theme.lineHeights.h4};
    letter-spacing: ${props => props.theme.letterSpacing.h4};
  }

  svg {
    color: ${props => props.theme.colors.claytonBlue};
    margin-right: 0.625rem;
  }
`;
